import React from "react";
import CloseButton from "../CloseButton";

import { Container } from "./styles";

type Props = {
  onClose?: () => void;
};

const ModalContentHeader: React.FC<Props> = ({ onClose }) => {
  return (
    <Container>
      <CloseButton onClose={onClose} />
    </Container>
  );
};

export default ModalContentHeader;
